export default __webpack_public_path__ + "static/media/4153079N8739049W.efb4fa4c.jpg";